/**
 * Auth event system for cross-component auth state synchronization
 * Dispatches events when auth state changes so components can refresh
 */

const AUTH_CHANGE_EVENT = "auth:change";

/**
 * Dispatch an auth change event
 * Call this after successful login, signup, or logout
 */
export function dispatchAuthChange() {
  window.dispatchEvent(new CustomEvent(AUTH_CHANGE_EVENT));
}

/**
 * Listen for auth change events
 * @param callback Function to call when auth changes
 * @returns Cleanup function to remove the listener
 */
export function onAuthChange(callback: () => void) {
  window.addEventListener(AUTH_CHANGE_EVENT, callback);
  return () => window.removeEventListener(AUTH_CHANGE_EVENT, callback);
}
